import React from 'react';
import './ProvinceWarArt.css';

const sprites:Record<string,number[]>={banner:[10,308,378,570],frame:[900,20,865,349],tab:[593,370,195,83],active:[385,365,210,91],
  back:[388,462,339,88],join:[980,372,538,165],create:[970,538,550,166],rank:[394,650,140,140],gift:[536,650,140,140],rules:[677,650,140,140],help:[816,650,140,140],
  swords:[1090,570,120,100]};
export function RoomSprite({name,assetBase=`${process.env.REACT_APP_CDN_PATH??''}features/province-war`}:{name:string;assetBase?:string}){
  const [x,y,w,h]=sprites[name];
  return <svg aria-hidden="true" preserveAspectRatio="none" viewBox={`${x} ${y} ${w} ${h}`} className="war-room-sprite"><image href={`${assetBase}/room/spritesheet.png`} width={1774} height={887}/></svg>;
}
